<template>
    <table-base
        :filter="filter"
        :headers="headers"
        :api-data="apiData"
        :sorting="sorting"
        :items-field="itemsField"
        :edit-page-name="editPageName"
        :api-method="apiMethod"
        :claim-name="claimName"
        :form-title="formTitle"
        :excel-title="excelTitle"
        :has-edit-page="hasEditPage"
        :table-form="auditorMemberForm"
        :refresh-key="refreshTabsKey"
        :show-expand="false"
        :set-api-data="setApiData"
        :show-buttons="true">
        <template v-slot:tabs>
            <v-row>
                <v-col>
                    <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                        <v-btn @click="toggleFinished(false)"> Active </v-btn>
                        <v-btn @click="toggleFinished(true)"> Finished </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </template>
    </table-base>
</template>

<script>
    import dateUtility from '../services/dateUtility'

    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                auditorMemberForm: () => import('../forms/AuditorMemberForm'),
                headers: [
                    { text: 'Auditor', value: 'auditorId', table: 'auditors', form: () => import('../forms/AuditorForm') },
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'End On', value: 'endOn', format: this.formatDate },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    auditors: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "auditorId", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'auditorMembers',
                editPageName: 'auditorMember',
                apiMethod: 'AuditorMembers',
                claimName: 'AuditorMembers',
                formTitle: 'Auditor Member',
                excelTitle: 'Auditor Members',
                hasEditPage: false,

                displayFinished: false,
                refreshTabsKey: 0,
            }
        },

        methods: {
            setApiData(data) {
                this.$set(this.apiData, 'auditors', data.auditors);
                this.$set(this.apiData, 'members', data.members);
                var currentDate = dateUtility.getCurrentDateIso();
                this.$set(this.apiData, 'items', data.items.filter((i) => {
                    var timeSpan = i.endOn !== null ? dateUtility.getDifference(currentDate, i.endOn) : null;
                    return this.displayFinished ?
                        timeSpan >= 0 :
                        timeSpan < 0 || timeSpan === null;
                }));
            },
            toggleFinished(displayFinished) {
                this.displayFinished = displayFinished;
                this.refreshTabsKey += 1;
            }
        },
        watch: {
            refreshKey() {
                this.refreshTabsKey++;
            }
        }
    };
</script>
